module.exports = __webpack_public_path__ + "img/corporate.b0fb3790.png";